var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md9":"","lg6":""}},[_c('Profile',{attrs:{"titleflag":'FillProfile'}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }